<div bsModal #staticModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-static"
     [config]="{backdrop: 'static'}" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 id="dialog-static" class="modal-title pull-left">
                    Move
                </h4>
                <button type="button" class="close pull-right" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="medium-padding remove-margin">
                    <h4>Select the new folder for: <span class="highlight">{{itemName}}</span></h4>
                    <div class="folder-container">
                        <ng-container [ngTemplateOutlet]='selectFolderChildrenTemplate' [ngTemplateOutletContext]="{folders:[folderStructure]}"></ng-container>
                    </div>

                </div>

            </div>
            <footer class="text-end">
                <div>
                    <button type="button" class="btn btn-link" (click)="close()">Cancel</button>
                    <button type="button" class="btn btn-success" [disabled]="selectedFolder == null" (click)="onSelectFolderAndClose()">Move to selected folder</button>
                </div>
            </footer>
        </div>
    </div>
</div>

<ng-template #selectFolderChildrenTemplate let-folders="folders">
    <ng-container *ngFor="let folder of folders">
        <div [class.folder-level]="folder?.folderId != null">
            <ng-container [ngTemplateOutlet]='folderRowTemplate' [ngTemplateOutletContext]="{folder:folder}"></ng-container>
            <ng-container *ngIf="folder?.isExpanded" [ngTemplateOutlet]='selectFolderChildrenTemplate' [ngTemplateOutletContext]="{folders:folder.folders}"></ng-container>
        </div>
    </ng-container>
</ng-template>


<ng-template #folderRowTemplate let-folder="folder">
    <div class="folder row" [class.selected]="isSelectedFolder(folder)" *ngIf="!isFolderExcluded(folder)">
        <div class="col-md-10 name-container" (click)="toggleExpandFolder(folder)">
            <div class="expand-arrow">
                <i  class="fa"
                    *ngIf="folder?.folders && folder?.folders.length > 0"
                    [ngClass]="{
                        'fa-chevron-right' : !folder?.isExpanded,
                        'fa-chevron-down': folder?.isExpanded
                    }"
                ></i>
            </div>

            <div class="name">
                <i class="fa fa-folder"></i>{{folder?.folderName || 'Files (top level)'}}
            </div>
        </div>
        <div class="col-md-2 text-end">
            <div class="selected-msg" *ngIf="isSelectedFolder(folder)">
                <i class="fa fa-check"></i> Selected folder
            </div>
            <div *ngIf="folder?.folderId == currentFolderId" class="text-muted font-light">
                Current file location
            </div>
            <button *ngIf="folder?.folderId !== currentFolderId" class="btn btn-toggle pull-right" (click)="toggleSelectedFolder(folder)">{{isSelectedFolder(folder) ? 'Unselect folder' : 'Select folder'}}</button>
        </div>
    </div>
</ng-template>
